require('babel-polyfill');

import Vue from 'vue';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import VuePages from './pages/plugin';
import Auth from './auth/auth';
import EventBus from './auth/event_bus';
import App from './App.vue';
import Format from './format';

import Organizations from './Organizations.vue';

Vue.use(VueRouter);
Vue.use(VuePages);
Vue.use(VeeValidate);
Vue.use(Auth);
Vue.use(Format);


// router

const routes = [
  { path: '/', component: Organizations }  
];

const router = new VueRouter({ routes: routes });

new Vue({
  router,
  el: '#app',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js